// src/pages/calendar/bookings/BookingFilters.js
import React from "react";
import styled from "@emotion/styled";
import { alpha } from "@mui/material/styles";
import { Box, Chip } from "@mui/material";

// Styled components
const FilterContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  padding: theme.spacing(2, 2, 1, 2),
}));

// Status chip with styled props
const StatusChip = styled(Chip)(({ theme, selected, chipcolor }) => ({
  margin: theme.spacing(0.5),
  fontWeight: selected ? 600 : 400,
  backgroundColor: selected
    ? chipcolor && chipcolor !== "default"
      ? alpha(theme.palette[chipcolor].main, 0.2)
      : alpha(theme.palette.primary.main, 0.15)
    : alpha(theme.palette.grey[400], 0.1),
  color: selected
    ? chipcolor && chipcolor !== "default"
      ? theme.palette[chipcolor].main
      : theme.palette.primary.main
    : theme.palette.grey[700],
  "&:hover": {
    backgroundColor: selected
      ? chipcolor && chipcolor !== "default"
        ? alpha(theme.palette[chipcolor].main, 0.2)
        : alpha(theme.palette.primary.main, 0.15)
      : alpha(theme.palette.grey[400], 0.2),
  },
}));

// Filter options configuration - remove "all" and make "upcoming" first
const filterOptions = [
  { value: "upcoming", label: "Upcoming", color: "success" },
  { value: "unconfirmed", label: "Unconfirmed", color: "warning" },
  { value: "recurring", label: "Recurring", color: "info" },
  { value: "past", label: "Past", color: "default" },
  { value: "canceled", label: "Canceled", color: "error" },
];

function BookingFilters({ filterStatus, setFilterStatus }) {
  // Handle filter chip click
  const handleFilterClick = (value) => {
    setFilterStatus(value);
  };

  return (
    <FilterContainer>
      {filterOptions.map((option) => (
        <StatusChip
          key={option.value}
          label={option.label}
          chipcolor={option.color}
          selected={filterStatus === option.value}
          onClick={() => handleFilterClick(option.value)}
          clickable
        />
      ))}
    </FilterContainer>
  );
}

export default BookingFilters;
